module.exports = __webpack_public_path__ + "static/media/epreselec.2385a4c4.png";